import { isSafeExternalUrl } from "./external-url";

/**
 * The ONE place the widget opens a link taken from BE / operator / host data (message buttons, AI
 * reply links, source links, quick actions). Anything outside the `isSafeExternalUrl` allowlist
 * (`javascript:`, `data:`, relative, ...) is dropped. Returns whether a tab was opened.
 */
export function openExternalUrl(url: unknown): boolean {
  if (!isSafeExternalUrl(url)) return false;
  window.open(url.trim(), "_blank", "noopener,noreferrer");
  return true;
}

/** Only phone punctuation is accepted; anything else (letters, `;`, a scheme) means "not a number". */
const PHONE_CHARS = /^[\d\s()+\-.]+$/;

/** `tel:` URL made of digits and an optional leading `+` only, or `null` when it is not a phone number. */
export function phoneToTelUrl(phone: unknown): string | null {
  if (typeof phone !== "string" || !PHONE_CHARS.test(phone)) return null;
  const digits = phone.replace(/\D/g, "");
  if (!digits) return null;
  return `tel:${phone.trim().startsWith("+") ? "+" : ""}${digits}`;
}

/** Dial a BE-provided number via a sanitised `tel:` link. Returns whether it navigated. */
export function openPhone(
  phone: unknown,
  navigate: (href: string) => void = (href) => {
    window.location.href = href;
  },
): boolean {
  const href = phoneToTelUrl(phone);
  if (!href) return false;
  navigate(href);
  return true;
}
